"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transmission = void 0;
exports.getTransmission = getTransmission;
const lodash_1 = __importDefault(require("lodash"));
function getTransmission(transName) {
    if (!transName)
        return null;
    let x = transName.trim();
    let trans_type = null;
    let trans_gears = null;
    try {
        if (/cvt|xtronic|variable|continuously variable/i.test(x)) {
            trans_type = 'CVT';
        }
        else if (/aut|manumatic|tiptronic|dsg|^[2-9]a|10a|^a$|^a\/t$|^at$/i.test(x)) {
            trans_type = 'A';
        }
        else if (/man|[2-9]m|m\/t$|stick/i.test(x)) {
            trans_type = 'M';
        }
        let y = x.match(/10|11|12|[0-9]/g);
        if (y !== null) {
            trans_gears = parseInt(y.join(''));
        }
        if (!trans_gears) {
            const match = transName.match(/(\d+)[-\s]?speed/i);
            if (match) {
                trans_gears = lodash_1.default.toNumber(match[1]);
            }
        }
        return {
            name: transName,
            trans_type,
            trans_gears
        };
    }
    catch {
        return null;
    }
}
exports.transmission = [
    {
        id: 'A',
        type: 'A',
        value: 'A',
        name: 'Automatic',
        gears: [1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 18]
    },
    {
        id: 'CVT',
        type: 'CVT',
        value: 'CVT',
        name: 'CVT',
        gears: [0, 6, 7, 8],
    },
    {
        id: 'M',
        type: 'M',
        value: 'M',
        name: 'Manual',
        gears: [3, 4, 5, 6, 7, 9, 10, 13, 15, 18]
    }
];
